import React, { useEffect, useState } from 'react'
import { ClientsDashbaordTicketView } from '../../views'
import { ClientsService, LocalStorageService } from '../../../services';
import { useParams, useHistory } from 'react-router-dom';
import { ModalUtil } from '../../pures';
import { useTranslation } from 'react-i18next';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
const clientsService = new ClientsService(url)

// La sesión se lee en cada handler (no en el scope del módulo): este módulo se
// importa de forma eager desde routes/index.js, antes de que exista el login.
const getToken = () => localStorageService.getLocalStorageItem("token")?.idToken

function ClientsDashboardTicketAction() {
    const { ticketId } = useParams()
    const history = useHistory();

    const { t } = useTranslation();
    const modalUtil = new ModalUtil()

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const toggleError = (message) => setErrorMessage(message)

    const onLoad = async () => {
        try {
            setIsLoading(true)
            toggleError(null)
            const data = await clientsService.getTicketDetails(getToken(), ticketId)
            setData(data)
            setIsLoading(false)
        } catch (error) {
            console.log(error)
        }
    }

    const handleBack = () => {
        history.goBack()
    }

    useEffect(() => {
        onLoad()
    }, [])

    return (
        <ClientsDashbaordTicketView
            isLoading={isLoading}
            //errorMessage={errorMessage}
            data={data}
            handleBack={handleBack}
        />
    )
}

export default ClientsDashboardTicketAction